import {
  priceLabelClassName,
  priceSignClassName,
  priceValueClassName,
  priceWrapperClassName,
  summaryPriceClassName,
} from './styles';

const SummaryPrice = () => {
  return (
    <div className={summaryPriceClassName}>
      <div className={priceWrapperClassName}>
        <span className={priceSignClassName}>$</span>
        <span className={priceValueClassName}>5</span>
      </div>
      <span className={priceLabelClassName}>per card, billed one-time</span>
    </div>
  );
};

SummaryPrice.displayName = 'SummaryPrice';

export default SummaryPrice;
